
document.addEventListener('DOMContentLoaded', function(){
  const form=document.getElementById('product-form'); if(!form) return;
  form.querySelectorAll('[data-option-name]').forEach(group=>{
    group.querySelectorAll('[data-option-value]').forEach(btn=>{
      btn.addEventListener('click', function(){
        group.querySelectorAll('[data-option-value]').forEach(b=>b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const name=group.getAttribute('data-option-name');
        const value=btn.getAttribute('data-option-value');
        const input=form.querySelector('input[name="options['+name+']"]');
        if(input) input.value=value;
      });
    });
  });
});
